(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-generated-badge"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!event.target.closest('.ai-generated-badge')) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.closest('.ai-generated-badge')) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);
  } catch(e) { console.error(e); }
})();

})();
